export type BoschUiLinkTargetType = '_self' | '_blank';

export type BoschUiLinkType = 'integrated' | 'button' | 'button-secondary' | 'button-integrated' | null;

export enum BoschUiLinkSizeEnum {
  S = 'S',
  M = 'M',
  L = 'L',
  XL = 'XL',
  XXL = '2XL',
  XXXL = '3XL',
  XXXXL = '4XL',
  XXXXXL = '5XL',
  XXXXXXL = '6XL',
}
